var ConfigureViewPresetSize = /** @class */ (function () {
    function ConfigureViewPresetSize(id, name, width, height) {
        if (width === void 0) { width = 0; }
        if (height === void 0) { height = 0; }
        this.id = id;
        this.name = name;
        this.width = width;
        this.height = height;
    }
    return ConfigureViewPresetSize;
}());
export { ConfigureViewPresetSize };
